import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLocale } from "@/i18n/detect";

const FAQ = () => {
  const { ui } = useLocale();
  const t = ui.faq;
  return (
    <section id="faq" className="bg-muted/40 py-24">
      <div className="container max-w-3xl">
        <div className="text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">{t.eyebrow}</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            {t.title}
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {t.items.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="rounded-xl border border-border bg-card px-6 shadow-card">
              <AccordionTrigger className="text-left font-display text-lg font-semibold text-secondary hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
